import { BaseRecordModel } from '../base-record.model';

export interface SmsRecordModel extends BaseRecordModel {
  smsMessageId?: string;
  smsContent: string;
  smsStatusSent: boolean;
  smsStatusDelivered?: boolean;
  smsStatusDeliveredTimestamp?: Date;
  smsStatusFailed?: boolean;
  smsStatusFailedTimestamp?: Date;
  smsStatusFailedMessage?: string;
  processedTimestamp: Date;
  creditUsed: number;
  smsStatusCode: number;
  smsErrorMessage: string;
  message: string;
}
